/* eslint-disable import/order */
import { useEffect } from 'react';
import { SERVICE_DESK_PROJECT } from '@jira/platform__project-types/src/project-types.tsx';
// eslint-disable-next-line jira/restricted/unsafe-global-state-stores
import { useProjectType } from '@jira/issue__project-context-service/src/useProjectKey.tsx';
import type { UseResourceCustomContext } from '@jira/platform__routing-router-resource-with-custom-router-context/src/controllers/types.tsx';
import { useResourceWithCustomRouterContext } from '@jira/platform__routing-router-resource-with-custom-router-context/src/controllers/use-resource-with-custom-router-context/index.tsx';
import { serviceDeskContextResource } from '@jira/router-resources__service-desk-context/src/serviceDeskContextResource.tsx';
import type { ServiceDeskContextData } from '@jira/navigation-apps__shared-types/src/types.tsx';

type ProjectKey = string;

type ProjectKeyRouteParams = {
	projectKey: ProjectKey;
};

export interface PracticeQueueRouteParams extends ProjectKeyRouteParams {
	practiceType?: string;
	queueId?: number;
}

const getServiceDeskContextResource = () => serviceDeskContextResource;

export const useServiceDeskContext = (
	projectKey?: string,
	customContext?: UseResourceCustomContext<PracticeQueueRouteParams>,
	options?: {
		shouldPrefetch?: boolean;
	},
): readonly [
	{
		readonly data: ServiceDeskContextData | null;
		readonly loading: boolean;
		readonly error: // oxlint-disable-next-line @typescript-eslint/no-explicit-any
			| Record<string, any>
			| Error // oxlint-disable-next-line @typescript-eslint/no-explicit-any
			| (Record<string, any> & Error) // oxlint-disable-next-line @typescript-eslint/no-explicit-any
			| (Error & Record<string, any>)
			| null;
	},
] => {
	const projectType: string | undefined = useProjectType(projectKey ?? '');

	const {
		data,
		loading,
		error,
		refresh: refreshCache,
	} = useResourceWithCustomRouterContext(getServiceDeskContextResource(), customContext, options);

	useEffect(() => {
		if (!__SERVER__) {
			// Only refresh cache if project type is SERVICE_DESK_PROJECT
			if (projectType === SERVICE_DESK_PROJECT) {
				refreshCache();
			}
		}
	}, [projectKey, refreshCache, projectType]);

	return [{ data, loading, error }] as const;
};
